import Element from "./index";
import { RouteType } from "routes/types";

const route: RouteType = {
  id: 1340,
  parentId: 1300,
  name: "TechnicalReports",
  label: "Technical Reports",
  path: "technical_reports",
  element: Element,
  footer: true,
  user: false,
  admin: false,
  hidden: false,
};

export default route;
